module.exports = __webpack_public_path__ + "static/colorblindness-1c2ec2c904e83b5a62959e6e6b42340d.png";